module.exports=function(n){return function(o){n.forEach(function(n){"function"==typeof n?n(o):null!=n&&(n.current=o)})}};
//# sourceMappingURL=index.js.map
